export enum Environment {
    Staging = 'stage',
    Production = 'prod',
    Testing = 'testing',
}